<template>
  <div>
    <b-navbar toggleable="sm" type="dark" variant="secondary">
      <b-navbar-brand href="#">
        <h2 class="sidebar-title-pink text-default">Pink <span class="text-pink">Workout</span></h2>
      </b-navbar-brand>

      <!-- <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item :to="{ name: 'Login' }" exact-active-class="active">Login</b-nav-item>
          <b-nav-item :to="{ name: 'Signup' }" exact-active-class="active">Registro</b-nav-item>
        </b-navbar-nav>

      </b-collapse> -->
    </b-navbar>
    <router-view></router-view>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        model: {
          email: '',
          password: '',
          rememberMe: false
        }
      };
    },
    methods: {
      onSubmit() {
        // this will be called only after form is valid. You can do api call here to login
      }
    },
    mounted() {
      document.body.classList.add('bg-gradient-primary')
    },
    destroyed() {
      document.body.classList.remove('bg-gradient-primary')
    }
  };
</script>
